export function formatPhoneRu(phone) {
  if (!phone) return "";
  const digits = String(phone).replace(/\D/g, "");

  // use last 10 digits as local number
  if (digits.length < 10) {
    return phone;
  }

  const last10 = digits.slice(-10);
  const p1 = last10.slice(0, 3);
  const p2 = last10.slice(3, 6);
  const p3 = last10.slice(6, 8);
  const p4 = last10.slice(8, 10);

  return `+7 (${p1}) ${p2}-${p3}-${p4}`;
}
